//文字コードはutf-8
// アンカー

export function anchor() {
  $(function () {
    $('.jsAnchor').click(function (e) {

      const href = $(this).attr('href');
      if (!href || !href.includes('#')) return;

      e.preventDefault();

      const hash = href.split('#')[1];
      const $target = $('#' + hash);
      if (!$target.length) return;

      const adjust = -120;
      const speed = 400;
      const $modalContent = $('.modModal__content');
      const $scrollContainer = $modalContent.length ? $modalContent : $('html, body');
      let position;

      if ($modalContent.length) {
        position = $target.position().top + $modalContent.scrollTop();
      } else {
        position = $target.offset().top + adjust;
      }
      $scrollContainer.stop(true).animate({ scrollTop: position }, speed, 'swing');

    });
  });
}